import { Injectable } from '@angular/core';
import { BaseServiceWithFilter } from '.';
import { Card } from '@cl/shared/models/cards/card.model';
import { HttpClient } from '@angular/common/http';
import { CommandResult } from '@cl/shared/models';
import { Observable } from 'rxjs';
import { CardFilter } from '@cl/shared/models/cards/card-filter.model';

@Injectable({
    providedIn: 'root',
})
export class CardsService extends BaseServiceWithFilter<Card, CardFilter> {
    constructor(protected httpClient: HttpClient) {
        super(httpClient, '/api/v1/cards/');
    }

    getDepartmentFuelCards(departmentId: number): Observable<CommandResult<Card[]>> {
        return this.httpClient.get<CommandResult<Card[]>>(`${this.baseApiUrl}department-fuel-cards/${departmentId}`);
    }

    getAllUsersDepartmentsFuelCards(): Observable<CommandResult<Card[]>> {
        return this.httpClient.get<CommandResult<Card[]>>(`${this.baseApiUrl}all-users-departments-fuel-cards`);
    }

    getDepartmentProductCards(departmentId: number): Observable<CommandResult<Card[]>> {
        return this.httpClient.get<CommandResult<Card[]>>(`${this.baseApiUrl}department-product-cards/${departmentId}`);
    }

    getAllUsersDepartmentsProductCards(): Observable<CommandResult<Card[]>> {
        return this.httpClient.get<CommandResult<Card[]>>(`${this.baseApiUrl}all-users-departments-product-cards`);
    }

    toString(object: Card): string {
        return `${object.performer.name ?? ''} ${object.performer.surname ?? ''} - ${object.number} (${object.cardService.name})`;
    }
}
